export default (theme) => ({
  root({ breakpoint }) {
    return {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down(breakpoint)]: {
        flexDirection: 'column !important',
        marginBottom: theme.spacing(1),
      },
    };
  },
  content({ breakpoint }) {
    return {
      maxWidth: '65%',
      margin: theme.spacing(1),
      [theme.breakpoints.down(breakpoint)]: {
        maxWidth: '100%',
      },
    };
  },
  pictureContainer: {
    textAlign: 'left',
    margin: theme.spacing(2),
    alignSelf: 'center',
  },
  picture: {
    maxWidth: '289px',
  },
  hasPictureOnRight: {
    flexDirection: ['row-reverse', '!important'],
  },
});
